import { select as d3_select, create as d3_create } from 'd3-selection'
// import {xml as d3_xml} from 'd3-fetch'
import { mergeConfig } from '../utils/configUtils'
import { serializeSVG, getDownloadUrl } from '../utils/exportUtils'
import { divToSVGText, FONTS, generateFontStyleElement, textToSVGText } from '../utils/fontUtils'
import LegendBehavior from '../viz_behaviors/LegendBehavior'
import TooltipBehavior from '../viz_behaviors/TooltipBehavior'
// import detector from '../utils/textUtils'
import { dentedRect } from '../utils/pathUtils'
// import {formatNumber} from '../utils/formatUtils'
// import oecd_logo from '../styles/icons/Banco_oecd_logo.svg'
// import oecd_logo from '../styles/icons/Logo-OECD.svg'
import * as COLORS from '../utils/colorUtils'
// import AnnotationBehavior from '../viz_behaviors/AnnotationBehavior'
import { svgfontCheck } from '../utils/fontUtils'
import { sanitizeData } from '../utils/dataUtils'
export default class BaseViz {
  static defaultConfig = {
    /**
     * Skin of the chart. Background and default colorscheme will change according to the skin.
     */
    skin: {
      type: String,
      default: 'light',
      options: ['light', 'dark'],
      exposed: true,
    },

    /**
     * Main title of the chart.
     */
    title: {
      type: String,
      default: 'Title',
      exposed: true,
    },
    /**
     * Subtitle of the chart.
     */
    subTitle: {
      type: String,
      default: 'Subtitle',
      exposed: true,
    },
    /**
     * Show or hide the "OECD" logo on the bottom-right of the chart.
     */
    showLogo: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    /**
     * Text to credit the source of the data. Leave blank (`''`) to hide.
     */
    sourceCredits: {
      type: String,
      default: 'default data source',
      exposed: true,
    },
    /**
     * Link to the source credits.
     */
    sourceLink: {
      type: String,
      default: '',
      exposed: true,
    },
  }

  static behaviors = [
    TooltipBehavior,
    LegendBehavior,
    // AnnotationBehavior
  ]

  constructor($root) {
    //,config) { ???

    const resizeObserver = new ResizeObserver(() => {
      setTimeout(this.afterChartUpdate.bind(this), 100)
    })
    resizeObserver.observe($root)

    this.$root = $root
    // this.$root.style.border = 'solid 1px #DEEDF2'

    // d3_select($root).style('overflow', 'hidden')
    let colsWrapper = d3_select($root)
      .append('div')
      .attr('class', 'cols-wrapper')
      .style('display', 'flex')
      .style('width', '100%')
      .style('height', '100%')

    colsWrapper
      .append('div')
      .attr('class', 'col-left')

    let contentWrapper = colsWrapper
      .append('div')
      .attr('class', 'wrapper col-main')
      // .style('margin', '16px')
      .style('width', 'calc(100%)') // -32px
      .style('height', 'calc(100%)') // -32px

    contentWrapper
      .style('display', 'flex')
      .style('flex-direction', 'column')
      .style('position', 'relative')
      .style('font-family', 'oecd-microtext-embedded')
      .style('user-select', 'none')

    contentWrapper
      .append('div')
      .attr('class', 'row-top')

    colsWrapper
      .append('div')
      .attr('class', 'col-right')

    // let headerRoot = contentWrapper.append('div').attr('class','header-container').style('text-align','left').style('position','relative')
    // this.$title = headerRoot.append('div').attr('class','title')
    //   .style('font-size','22px')
    //   .style('font-family','oecd-headline-bold-embedded')
    //   // .style('font-weight','bold')
    //   .node()
    // this.$separator = headerRoot.append('div').attr('class','separator rect')
    //   .style('width','28px')
    //   .style('height','3px')
    //   .style('background-color',COLORS.PRIMARY_COLOR)
    //   .style('margin','10px 0 7px 0').node()
    // this.$subTitle = headerRoot.append('div').attr('class','sub-title')
    //   .style('font-size','18px')
    //   .style('font-weight','regular').node()
    // // this.$headerRoot = headerRoot.node()

    this.$chartRoot = contentWrapper
      .append('svg')
      .attr('class', 'chart-container row-main')
      .style('width', '100%')
      .style('flex', '1 1 auto')
      .node()

    contentWrapper
      .append('div')
      .attr('class', 'row-bottom')

    this.$legendRoot = contentWrapper
      .append('div')
      .attr('class', 'legend-container')
      .node()

    // let footerRoot = contentWrapper.append('div').attr('class','footer-container')
    //   .style('display','flex')
    //   .style('justify-content','space-between')
    //   .style('align-items','flex-end')
    //   .style('position','relative')
    //   .style('margin-top','10px')
    // this.$sourceRoot = footerRoot.append('div').attr('class','source-container')
    //   .style('font-size','12px')
    //   .style('line-height','10px')
    //   .node()

    // this.$logoRoot = new DOMParser().parseFromString(oecd_logo, "image/svg+xml").documentElement
    // this.$logoRoot.setAttribute('class','logo')
    // this.$logoRoot.setAttribute('width', 100)
    // this.$logoRoot.setAttribute('height', 16)
    // this.$logoRoot.style.marginLeft = 'auto'
    // footerRoot.node().appendChild(this.$logoRoot)

    this.chart = new this.__proto__.constructor.chartClass(this.$chartRoot)

    this.chart.helperListeners.afterItemsHelper = this.afterItemsHelper.bind(this)
  }
  get data() {
    return this._data
  }
  set data(value) {
    value = sanitizeData(value)
    this._data = value
    this.beforeChartUpdate()
    this.chart.data = this.__proto__.constructor.dataControllerClass(value, this.config)
    this.afterChartUpdate()
  }

  get config() {
    return this._config
  }
  set config(value) {
    this._config = value
    this.beforeChartUpdate()
    //Dangerous, pero se necesita no?
    // Se necesita por ejemplo para el "minBarHeight" de los barcharts...
    // entiendo qeu seteando el data directamente (_data) y luego el config por el setter solo se pinta una vez, no?!
    if (this.data)
      this.chart._data = this.__proto__.constructor.dataControllerClass(this.data, this.config)
    this.chart.config = this.config
    this.afterChartUpdate()
  }
  beforeChartUpdate() {
    // this.$title.innerHTML = this.config.title
    // this.$subTitle.innerHTML = this.config.subTitle

    // this.$separator.style.display = this.config.title!==''?'block':'none'
    // this.$title.style.display = this.config.title!==''?'block':'none'
    // this.$subTitle.style.display = this.config.subTitle!==''?'block':'none'

    this.$root.style.transition = 'background-color .8s'
    // console.log('setting skin styles', this.config.skin)
    // config: skin
    if (this.config.skin === 'dark') {
      this.$root.style.backgroundColor = COLORS.SKIN_BACKGROUND_DARK
      this.$root.style.color = '#fff'
      // this.$title.style.color = '#fff'
      // this.$subTitle.style.color = '#ddd'
      // this.$sourceRoot.style.color = '#ddd'
      // this.$logoRoot.children[0].style.fill='#ddd'
    } else {
      this.$root.style.backgroundColor = COLORS.SKIN_BACKGROUND
      this.$root.style.color = '#888'
      // this.$title.style.color = '#222'
      // this.$subTitle.style.color = '#666'
      // this.$sourceRoot.style.color = '#666'
      // this.$logoRoot.children[0].style.fill='#666'
    }

    // config: sourceCredits
    //ya se "quita" con innerHTML = '' :D
    // if(this.config.sourceLink && this.config.sourceLink !== ''){
    //   let propperLink = this.config.sourceLink
    //   if(propperLink.indexOf('http')<0) propperLink = 'http://'+propperLink
    //   this.$sourceRoot.innerHTML = `<a href="${propperLink}" style="color: inherit" target="_blank">${this.config.sourceCredits}</a>`
    // } else {
    //   this.$sourceRoot.innerHTML = this.config.sourceCredits
    // }

    // config: showLogo
    // this.$logoRoot.style.display = this.config.showLogo?'block':'none'
    // this.$sourceRoot.style.display = this.config.sourceCredits!==''?'block':'none'
  }
  // WARNING: esto estaba asi, pero al acorn no le gustaba...
  // afterItemsHelper = () => {
  afterItemsHelper() {
    if (this.data) {
      if (this.config.LegendBehavior.showLegend) {
        let icon = (this.config.LegendBehavior && this.config.LegendBehavior.icon) || 'circle'
        LegendBehavior(this.$legendRoot, this.chart, { icon: icon })
      } else {
        this.$legendRoot.innerHTML = ''
      }
      TooltipBehavior(this.chart, this.config.TooltipBehavior || {})
    }
  }
  afterChartUpdate() {
    // if(this.config && this.config.AnnotationBehavior) AnnotationBehavior(this.$chartRoot,this, this.config.AnnotationBehavior)
  }

  _getConfig() {
    let behaviorsConfig = this.__proto__.constructor.behaviors.reduce((config, bh) => {
      config[bh.configName] = bh.defaultConfig
      return config
    }, {})
    let baseConfig = mergeConfig(this.__proto__.constructor.defaultConfig, behaviorsConfig)

    let tmp = mergeConfig(baseConfig, this.constructor.defaultConfig)
    let tmp2 = this.constructor.chartClass.prototype._getConfig()
    let config = mergeConfig(tmp, tmp2)
    // TODO: falta mergear los "behaviros" ??
    return config
  }
  getSVGSource() {
    return this.getSVG().then(svg => {
      return serializeSVG(svg)
    })
  }
  getSVGURL() {
    return this.getSVGSource().then(source => getDownloadUrl(source))
  }
  getSVG() {
    return svgfontCheck().then(() => this._getSVG.call(this))
  }
  _getSVG() {
    // let copyTextStyles = (target,source) => {
    //   return target.attr('alignment-baseline','before-edge')
    //     .style('font-size',source.node().style.fontSize)
    //     .style('font-weight',source.node().style.fontWeight)
    //     .style('font-family',source.node().style.fontFamily || 'oecd-microtext-embedded')
    //     .attr('fill',source.node().style.color || 'currentColor')
    // }
    let cloneNode = (target, source) => {
      let clone
      let responsePromise
      if (source.node().classList[0] === 'logo') {
        let content = source.html()
        clone = target.append('g').html(content)
        clone.attr('transform', 'scale(0.5)')
      } else if (source.node().nodeName === 'svg') {
        let content = source.html()
        clone = target.append('g').html(content)
        let refs = []
        clone
          .node()
          .querySelectorAll('text')
          .forEach($t => refs.push($t))
        source
          .node()
          .querySelectorAll('text')
          .forEach(($t, i) => {
            let t = d3_select($t)
            if (t.attr('display') !== 'none' && !(+t.style('opacity') === 0)) {
              textToSVGText(t, d3_select(refs[i].parentNode))
            }
            refs[i].remove()
          })
        // chapuzilla fills de gradients (safari)
        clone
          .node()
          .querySelectorAll('linearGradient')
          .forEach(h => (h.id = 'cloned-' + h.id))
        clone
          .node()
          .querySelectorAll('.gradient-rect')
          .forEach(h => (h.style.fill = h.style.fill.replace('#', '#cloned-')))
      } else if (source.node().children.length === 0) {
        let textContent = source.node().innerHTML
        if (textContent !== '') {
          divToSVGText(source, target)
        } else {
          let rect = source.node().getBoundingClientRect()
          let shape = source.node().classList[1]
          if (shape === 'dented-rect') {
            clone = target
              .append('path')
              .attr('d', () => {
                return dentedRect(rect.width, rect.height, 'tr', null, 4)
              })
              .attr('shape-rendering', 'crispedges')
          } else if (shape) {
            clone = target
              .append(shape)
              .attr('width', rect.width)
              .attr('height', rect.height)
              .attr('r', rect.width / 2)
              .attr('cx', rect.width / 2)
              .attr('cy', rect.height / 2)
              .attr('shape-rendering', 'crispedges')
          }
          if (clone) clone.attr('fill', source.node().style.backgroundColor)
        }
      } else {
        source.node().children.forEach($child => {
          if ($child.style.display !== 'none') {
            clone = target.append('g').attr('class', $child.classList)
            responsePromise = cloneNode(clone, d3_select($child))
          }
        })
      }
      let parentRect = source.node().parentNode.getBoundingClientRect()
      let childRect = source.node().getBoundingClientRect()
      target.attr(
        'transform',
        `translate(${childRect.x - parentRect.x},${childRect.y - parentRect.y})`
      )
      return responsePromise || new Promise(res => res())
    }

    let root = d3_select(this.$root)
    let frame = this.$root.getBoundingClientRect()
    let svg = d3_create('svg')
    svg
      .attr('width', frame.width)
      .attr('height', frame.height)
      .attr('color', this.$root.style.color)

    return cloneNode(svg, root).then(() => {
      // startDownload(svg.node(), this.config.title || this.componentLabel)
      svg.attr('transform', null)

      //PARECE QUE NO GUSTABA AL CHROME y NO SERVIA DE NADA !?!?!?!?
      // FONTS.forEach(fontDef => {
      //   let defs = svg.selectAll('defs').data([null])
      //   defs = defs.merge(defs.enter().append('defs'))
      //   let svgStyleElement = generateFontStyleElement(fontDef, 'svg')
      //   defs.node().appendChild(svgStyleElement)
      // })
      svg.node().innerHTML = svg.node().innerHTML.replaceAll('currentColor', this.$root.style.color)
      return svg.node()
    })
  }
}
